import { connect } from "react-redux";
import { deleteAvaterImage } from "../store/action";
import {
  ConfirmationDialog,
  CustomTooltip,
  SmallScreenModel,
} from "components";
import { useState } from "react";
import ConfirmationDialogMsg from "modules/video/components/ConfirmationDialogMsg";
import { TrashIcon } from "assets";

export interface avatarImageError {
  avatar_id: string;
  imageUrl?: string;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & avatarImageError;

const HandleDeleteAvatar: React.FC<Props> = ({
  avatar_id,
  onDeleteAvatar,
  imageUrl,
}) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const toggleDeleteDialog = () => {
    setIsDeleteDialogOpen(!isDeleteDialogOpen);
  };
  const handleDelete = () => {
    onDeleteAvatar(avatar_id);
  };
  return (
    <CustomTooltip placement="bottom" title={"Delete Avatar"}>
      <div
        onClick={() => setIsDeleteDialogOpen(true)}
        className=" border-4 border-primary-500 rounded-full p-2 bg-white cursor-pointer"
      >
        <TrashIcon className="text-red-500 hover:text-red-700 size-6 " />
        <SmallScreenModel
          showModal={isDeleteDialogOpen}
          setShowModal={setIsDeleteDialogOpen}
        >
          <ConfirmationDialog
            imageUrl={imageUrl}
            title={"Delete Avatar Image"}
            message={"Are you sure you want to delete?"}
            onConfirm={handleDelete}
            onCancel={toggleDeleteDialog}
            error={deleteError}
          />
        </SmallScreenModel>
      </div>
    </CustomTooltip>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onDeleteAvatar: (avatar_id: string) => dispatch(deleteAvaterImage(avatar_id)),
});

export default connect(null, mapDispatchToProps)(HandleDeleteAvatar);
